var _rect, _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisually(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 100,
    viewBox: "0 0 107 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 106,
    height: 100,
    rx: 50,
    fill: "#F7F8FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_2552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5105 31.2113C51.9058 31.2113 54.6582 28.4589 54.6582 25.0636C54.6582 21.6683 51.9058 18.9158 48.5105 18.9158C45.1151 18.9158 42.3627 21.6683 42.3627 25.0636C42.3627 28.4589 45.1151 31.2113 48.5105 31.2113Z",
    fill: "white",
    stroke: "#4540DB",
    strokeWidth: 1.83202,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8231 57.8804C41.1969 64.5385 39.5708 71.1983 37.9447 77.8599C37.8552 78.4316 37.9661 79.0166 38.2584 79.516C38.5508 80.0153 39.0067 80.3983 39.549 80.6001C40.1281 80.7995 40.7602 80.7803 41.3261 80.546C41.8921 80.3117 42.3528 79.8786 42.6216 79.3282C44.1081 73.7815 45.6008 68.2357 47.0995 62.6908C47.6166 62.5136 48.1741 62.4908 48.7039 62.6253C49.9366 62.9577 50.8657 64.2297 51.041 65.8314C52.3339 70.3539 53.6259 74.8755 54.9171 79.3962C54.972 79.4669 55.8592 80.5478 57.2568 80.3986C57.7578 80.3394 58.2315 80.1382 58.6219 79.8187C59.0123 79.4992 59.3033 79.0747 59.4605 78.5954L56.0581 63.6251L48.3034 55.0722L48.4369 42.9128L57.2568 53.3317C58.4947 54.1561 60.0729 54.075 61.0648 53.1983C62.1902 52.2011 62.0201 50.6622 62.0018 50.5235L48.5704 35.3439C47.6413 34.2054 46.16 33.8599 45.0948 34.4252C44.0872 34.9644 43.8569 36.1212 43.8255 36.2965C43.4905 43.492 43.1563 50.6866 42.8231 57.8804Z",
    fill: "white",
    stroke: "#4540DB",
    strokeWidth: 1.83202,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3257 57.111L50.0858 63.6697",
    stroke: "#4540DB",
    strokeWidth: 1.83202,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 53.9405L81.355 72.497L62 53.9405Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 53.9405L81.355 72.497",
    stroke: "#4540DB",
    strokeWidth: 1.83202,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_2552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 63.6576,
    fill: "white",
    transform: "translate(37 18)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisually);
export default __webpack_public_path__ + "static/media/Visually.e8bae8c41989528dce55baaff159fd48.svg";
export { ForwardRef as ReactComponent };